import { useMemo } from 'react';
import { useTypedAggregatorClient, PLACEHOLDER_EXPERIENCE } from '../../aggregator-client-context';
import { BITBUCKET_PRODUCT_ID } from './types';
export var useBitbucketPermissionSupplier = function useBitbucketPermissionSupplier(overridenPermissionsSupplier) {
  var client = useTypedAggregatorClient();
  return useMemo(function () {
    if (overridenPermissionsSupplier) {
      return overridenPermissionsSupplier;
    }
    return function () {
      return (client === null || client === void 0 ? void 0 : client.getProductScopes(BITBUCKET_PRODUCT_ID, PLACEHOLDER_EXPERIENCE)) || [];
    };
  }, [client, overridenPermissionsSupplier]);
};